import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { CamToolBuilder } from '../../models/builders/cam-tool.builder';
import { CamToolHolder } from '../../models/cam-tool-holder';

const camToolHolderBody = (camToolHolder: CamToolHolder) => ({
    hash: camToolHolder.hash,
    name: camToolHolder.name
  });

@Injectable()
export class CamToolHolderApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }camToolHolders`;
  }

  searchCamToolHolders(search: string) {
    const params = new HttpParams().append('search', search);

    return this.httpClient.get(`${ this.apiUrl }/search`, { params })
      .pipe(
        map(CamToolBuilder.buildCamToolHolderFromList)
      );
  }

  createCamToolHolder(camToolHolder) {
    // tslint:disable-next-line: max-line-length
    return this.httpClient.post(`${this.apiUrl}/`, camToolHolderBody(camToolHolder)).pipe(map(CamToolBuilder.buildCamToolHolderFromJson));
  }

  deleteCamToolHolder(camToolHolder: CamToolHolder) {
    return this.httpClient.delete(`${ this.apiUrl }/${ camToolHolder.hash }`);
  }

  getCamToolHolders() {
    return this.httpClient.get(`${ this.apiUrl }`).pipe(map(CamToolBuilder.buildCamToolHolderFromList));
  }

  getCamToolHolder(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`).pipe(map(CamToolBuilder.buildCamToolHolderFromJson));
  }

  updateCamToolHolder(camToolHolder: CamToolHolder) {
    const body = camToolHolderBody(camToolHolder);
    return this.httpClient.put(`${ this.apiUrl }/${ camToolHolder.hash }`, body);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/cam-tool-holder-api.service.ts